import useUpgradeUserLevel from '@/shahrzad-assets/shared-hooks/useUpgradeUserLevel'
import { useContext, useEffect } from 'react'
import { FullScreenModalContext } from '../shared_components/FullScreenModalContext'
import { UpgradeUserLevel } from '../shared_components/UpgradeUserLevel'

const useUpgradeLevelModal = () => {
  const modal = useContext(FullScreenModalContext)
  const modalTitle = 'ارتقاء سطح کاربری'

  const { loading, fetchUpgradeUserLevel, submitUpgradeUserLevelForm } =
    useUpgradeUserLevel()

  useEffect(() => {
    if (modal.isShow && modal.title == modalTitle) {
      modal.setComponent(
        <UpgradeUserLevel
          loading={loading}
          submitUpgradeUserLevelForm={submitUpgradeUserLevelForm}
        />,
      )
    }
  }, [loading])

  const openUpgradeUserModal = (e) => {
    e?.preventDefault()
    e?.stopPropagation()
    modal.setTitle(modalTitle)
    modal.setComponent(
      <UpgradeUserLevel
        loading={loading}
        submitUpgradeUserLevelForm={submitUpgradeUserLevelForm}
      />,
    )
    modal.show()
  }

  const closeUpgradeUserModal = (e) => {
    e?.preventDefault()
    e?.stopPropagation()
    modal.hide()
  }

  return { openUpgradeUserModal, closeUpgradeUserModal }
}

export default useUpgradeLevelModal
